import {
   Stack,
   ContentCard,
   Grid,
   Button,
   Group,
   Select,
} from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon, BoltIcon, ChevronRightIcon } from '@forwardflow/icons'
import { motion } from 'framer-motion'
import {
   IStage,
   useOnboardingStoreV2,
} from '@forwardflow/store/onboardingStoreV2'
import { StageMapGroup } from './stage-mapping/StageMapGroup'

export const StageMappingAppointmentStages = () => {
   const {
      getNextStep,
      getPreviousStep,
      onboardingData,
      setTempStageGroupByGroupId,
   } = useOnboardingStoreV2()
   const { tempStageGroups } = onboardingData
   const appointMentScheduledGroup = tempStageGroups?.find(
      (group) => group.groupId === 'ff-appointment-set'
   )
   const appointMentScheduledType = appointMentScheduledGroup?.type
   // const appointMentScheduledStages = appointMentScheduledGroup?.stageOrTags

   const appointMentMissedGroup = tempStageGroups?.find(
      (group) => group.groupId === 'ff-appointment-missed'
   )
   const appointMentMissedType = appointMentMissedGroup?.type
   // const appointMentMissedStages = appointMentMissedGroup?.stageOrTags

   const handleNextStep = () => {
      getNextStep()
   }

   const emptyStage = {
      id: '',
      name: '',
      description: '',
      type: 'stage',
   }

   return (
      <Stack gap={32}>
         <ContentCard
            className="space-y-2 !p-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
         >
            <Group>
               <Group className="p-2 px-2.5 rounded-[16.2px] border-[0.9px] border-[#8E51FF]/30 bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30">
                  <BoltIcon width={24} color="#9F7BFF" />
               </Group>
               <Stack gap={4}>
                  <p className="text-white font-medium">
                     How do you track appointments in your CRM?
                  </p>
                  <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
                     Tell Forward Flow which stages or tags you use when an
                     appointment is booked and when it's missed
                  </p>
               </Stack>
            </Group>
         </ContentCard>
         <ContentCard
            className="!p-6 space-y-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.3 }}
         >
            <p className="text-white font-medium mb-4">Appointment Scheduled</p>
            <Select
               label="Type"
               value={appointMentScheduledType}
               onChange={(value) =>
                  setTempStageGroupByGroupId('ff-appointment-set', {
                     groupId: 'ff-appointment-set',
                     parentGroupId: null,
                     stageOrTags:
                        value === 'appointment-field'
                           ? []
                           : ([emptyStage] as IStage[]),
                     type: value as 'appointment-field' | 'stage',
                  })
               }
               data={[
                  {
                     label: 'Appointment field in FUB',
                     value: 'appointment-field',
                  },
                  {
                     label: 'Stage',
                     value: 'stage',
                  },
               ]}
               description={
                  appointMentScheduledType === 'appointment-field'
                     ? 'We will understand whether a lead has appointment scheduled or not by looking at the appointment field in Follow Up Boss'
                     : ''
               }
            />

            {appointMentScheduledType === 'stage' && (
               <StageMapGroup hasBorder={false} groupId="ff-appointment-set" />
            )}
         </ContentCard>

         <ContentCard
            className="!p-6 space-y-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.3 }}
         >
            <p className="text-white font-medium mb-4">Appointment Missed</p>
            <Select
               label="Type"
               value={appointMentMissedType}
               onChange={(value) =>
                  setTempStageGroupByGroupId('ff-appointment-missed', {
                     groupId: 'ff-appointment-missed',
                     parentGroupId: null,
                     stageOrTags:
                        value === 'no-criteria'
                           ? []
                           : ([emptyStage] as IStage[]),
                     type: value as 'no-criteria' | 'stage',
                  })
               }
               data={[
                  {
                     label: 'No criteria',
                     value: 'no-criteria',
                  },
                  {
                     label: 'Stage',
                     value: 'stage',
                  },
               ]}
            />
            {appointMentMissedType === 'stage' && (
               <StageMapGroup
                  transitionDelay={0.6}
                  hasBorder={false}
                  groupId="ff-appointment-missed"
               />
            )}
         </ContentCard>

         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.9 }}
         >
            <Grid>
               <Grid.Col span={3}>
                  <Button
                     variant="secondary"
                     className="w-full"
                     onClick={() => getPreviousStep()}
                  >
                     <ArrowLeftMdIcon width={12} /> Back
                  </Button>
               </Grid.Col>
               <Grid.Col span={9}>
                  <Button
                     className="w-full"
                     onClick={() => handleNextStep()}
                     // disabled={
                     //    !appointMentMissedStages.every((stage) => stage.id) ||
                     //    (!appointMentStages.every((stage) => stage.id) &&
                     //       appointMentScheduledGroup.type === 'stage')
                     // }
                  >
                     Continue <ChevronRightIcon width={18} />
                  </Button>
               </Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
